module.exports = __webpack_public_path__ + "static/assets/6a29614772d45e22f5172740ebae0b82.svg";